import { render, staticRenderFns } from "./MultipleLicences.vue?vue&type=template&id=dd0401b2"
import script from "./MultipleLicences.vue?vue&type=script&lang=js"
export * from "./MultipleLicences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd0401b2')) {
      api.createRecord('dd0401b2', component.options)
    } else {
      api.reload('dd0401b2', component.options)
    }
    module.hot.accept("./MultipleLicences.vue?vue&type=template&id=dd0401b2", function () {
      api.rerender('dd0401b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/checkout/components/single/MultipleLicences.vue"
export default component.exports